export default "https://d1e6s5z4lzmgxx.cloudfront.net/1e48d3d4-9cd4-48c4-b169-1af184d58c4c/images/selected-star-icon.png?8bf913ccef025d6fcaeb1f735c592616";